module.exports = __webpack_public_path__ + "ba01f7c556768c39dfd4bb79891221db.fbx";